var headers = {
  type: 'text/plain; charset=UTF-8'
};

var createBlob = function createBlob(data) {
  return new Blob([JSON.stringify(data)], headers);
};

export var sendData = function sendData(data) {
  return window.navigator.sendBeacon('/page_events', createBlob(data));
};
export var sendBatch = function sendBatch(batch) {
  return window.navigator.sendBeacon('/page_events/batch', createBlob({
    batch: batch
  }));
};